import { useNavigate } from "react-router";
import { Button, EmptyState, PageHeader, PageShell, icons } from "@bruntworkwear-apps/ui";
import { useRun } from "@/app/providers";
import { useAppConfig } from "@/modules/overview";
import { ComparisonTable } from "./components/ComparisonTable";
import { ExportCard } from "./components/ExportCard";

/**
 * Step three: calculated against booked, and the export.
 *
 * The booked side comes from the accrual postings in the same upload, so there
 * is no second file to keep in step and no way for the two sides to be pulled
 * at different times.
 */
export function ReconciliationModule() {
  const navigate = useNavigate();
  const { result } = useRun();
  const config = useAppConfig();

  if (!result) {
    return (
      <PageShell>
        <PageHeader title="Reconciliation" />
        <EmptyState
          icon={<icons.Table2 size={28} />}
          title="No reconciliation yet"
          description="Upload both workbooks to compare calculated costs against what NetSuite accrued."
          action={<Button onClick={() => void navigate("/run")}>Start a run</Button>}
        />
      </PageShell>
    );
  }

  const threshold = config.data?.defaults.customs_variance_threshold ?? 200;
  const customsAccount = config.data?.accrued_customs_account ?? "20114";
  const landingAccount = config.data?.accrued_landing_account ?? "20113";

  return (
    <PageShell width="wide">
      <PageHeader
        title="Calculated against booked"
        description={`Booked figures come from accounts ${customsAccount} and ${landingAccount} in the same export.`}
        action={
          <Button variant="secondary" onClick={() => void navigate("/review")}>
            Back to review
          </Button>
        }
      />

      <ExportCard filename={result.workbook_filename} workbookBase64={result.workbook_base64} />

      <ComparisonTable receipts={result.receipts} threshold={threshold} />
    </PageShell>
  );
}
